import { render } from "./BaseFieldInTableHeader.vue?vue&type=template&id=259dec67"
import script from "./BaseFieldInTableHeader.vue?vue&type=script&lang=js"
export * from "./BaseFieldInTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__